import * as React from 'react';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import format from 'date-fns/format';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { Order, ProductPropertiesTypes } from '../../BookingsCalendarTypes';
import { formatKeyPickupAddress } from '../../utils/keyPickupUtils';

type ExtendedOrderListCardProps = {
    order: Order;
    labels: ExtendedOrderListCardLabels;
};

export type ExtendedOrderListCardLabels = {
    brokerName: string;
    brokerFirmName: string;
    message: string;
    images: string;
    preferredDate: string;
    client: string;
    ordered: string;
    internalComments: string;
    keyPickupAddress: string;
};

const ExpandedOrderListCard = (props: ExtendedOrderListCardProps) => {
    const { order, labels } = props;

    const orderDescription = order.orderRows
        ? order.orderRows
              .map((item) => item.productOverrideName || item.productOriginalName)
              .join(', ')
        : null;

    const hasKeyPickup = order.productProperties.some(
        (p) => p.value === ProductPropertiesTypes.KeyPickup
    );
    const keyPickupAddress = formatKeyPickupAddress(order);

    let StyledTypography = styled(Typography)(({ theme }) => ({
        fontWeight: '400',
        lineHeight: '150%',
        fontSize: '10px',
        textAlign: 'left',
        color: 'rgba(0, 0, 0, 0.87)'
    }));

    let row = (title: string, text: string) => {
        return (
            <>
                <Divider sx={{ margin: '0 -10px 10px -10px' }} />
                <Box sx={{ display: 'flex', alignItems: 'center', mb: '10px' }}>
                    <StyledTypography sx={{ width: '85px', fontWeight: '700' }}>
                        {title}:{' '}
                    </StyledTypography>
                    <StyledTypography sx={{ width: 'calc(100% - 85px)' }}>{text}</StyledTypography>
                </Box>
            </>
        );
    };

    const getPreferredDateString = () => {
        if (order.preferredDate && order.preferredTimeSlot) {
            let date = format(new Date(order.preferredDate), 'dd/MM/yyyy');
            let timeSlot = order.preferredTimeSlot;
            return date + ' ' + timeSlot;
        }
        if (order.preferredDate && !order.preferredTimeSlot) {
            return format(new Date(order.preferredDate), 'dd/MM/yyyy');
        }
        return '';
    };
    return (
        <Box sx={{ p: '10px', pt: '0', pb: '0' }} aria-label="card-dropdown">
            {order.preferredDate ? row(labels.preferredDate, getPreferredDateString()) : null}
            {order.customer.commentFromAgent && order.customer.commentFromAgent !== '\n'
                ? row(labels.message, order.customer.commentFromAgent)
                : null}
            {row(labels.client, order.customer.agentName + ', ' + order.customer.brokerFirmName)}
            {row(labels.ordered, orderDescription)}
            {hasKeyPickup ? row(labels.keyPickupAddress, keyPickupAddress || '—') : null}
            {order.internalComments && order.internalComments.trim() !== ''
                ? row(labels.internalComments, order.internalComments)
                : null}
        </Box>
    );
};

export default ExpandedOrderListCard;
